// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  // Increase padding for larger screens
  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const StatusContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  justify-items: start;
  padding: 1rem;
  align-items: center;

  // 3 columns + increase padding/gap for medium screens
  @media (min-width: ${BREAKPOINTS.sm}px) {
    grid-template-columns: 1fr 1fr 1fr;
    padding: 1.375rem 1.75rem;
    gap: 18px;
  };

  // Switch to flex layout on extra large screens (enough space for all items)
  // LG is now treated as tablet, so flex layout only applies from XL
  @media (min-width: ${BREAKPOINTS.xl}px) {
    display: flex;
    justify-content: space-between;
  };
`;

export const IndicatorsContainer = styled.div`
  flex-direction: column;
  display: flex;
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  border-radius: 4px;
  width: 100%;
`;
